import React from 'react';
import GearLoader from '../GearLoader';
import { useDocumentFormContext } from '../../../context/form/DocumentFormContext';
import { DocumentFormContent } from './DocumentFormContent';
import { useCurrentUserContext } from '../../../context/currentUser/CurrentUserContext';

export const GearDocumentForm: React.FC = () => {
  const { editedDocument } = useDocumentFormContext();
  const { selectedIndex } = useCurrentUserContext();

  if (!editedDocument) {
    return null;
  }

  if (selectedIndex?.id === undefined) {
    return <GearLoader />;
  }

  return <DocumentFormContent indexId={selectedIndex.id} />;
};
